<style>
#addUserAttributesModal .v-messages__message {
  line-height: unset;
}
</style>

<template>
  <Modal
    modalName="addUserAttributesModal"
    title="Dodaj atrybut użytkownika"
    :buttons="['add']"
    @add="addAttribute"
    @closed="closed"
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="25"
        label="Nazwa kolumny"
        autofocus
        required
      >
      </v-text-field>
      <v-select
        :items="types"
        item-text="display_name"
        label="Wybierz typ kolumny"
        v-model='selectedType'
        :rules="selectRules"
        :return-object="true"
        required
      >
      </v-select>
    </v-form>
  </Modal>
</template>

<script>
import Modal from '../../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({
    name: "",
    selectedType: undefined,
    nameRules: [
      v => !!v || 'Nazwa jest wymagana',
      v => (v && v.length <= 25) || 'Nazwa musi mieć mniej niż 25 znaków'
    ],
    selectRules: [
      v => !!v || 'Wybierz typ danych'
    ],
    valid: true,
    types: [
      {
        display_name: "Liczba całkowita",
        type: "integer"
      },
      {
        display_name: "Liczba podwójnej precyzji",
        type: "double precision"
      },
      {
        display_name: "Tekst",
        type: "text"
      },
      {
        display_name: "Data",
        type: "timestamp"
      }
    ]
  }),
  computed: {

  },
  methods: {
    closed() {
      this.valid = false;
      this.name = "";
      this.selectedType = undefined;
    },
    addAttribute() {
      if(this.$refs.form.validate()) {
        let payload = {
          table: this.$store.getters.getCurrentEditedLayer,
          display_name: this.name,
          type: this.selectedType.type
        }
        this.$store.dispatch('addField', payload).then(success => {
          if(success) {
            this.$modal.hide('addUserAttributesModal')
            this.$root.$emit('showSnackbar', 'success', 'Pomyślnie dodano kolumnę')
            this.$root.$emit("refreshList")
            this.$root.$emit("addedAttribute")
          }
          else {
            this.$root.$emit('showSnackbar', 'red', 'Podczas dodawania kolumny wystąpił błąd')
          }
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userAttributes/AddUserAttribute.vue